interface EligibilityAccess {
  hasAccess: boolean;
  isLoading: boolean;
}

/** Eligibility is available to all organizations, including billing identity setup. */
export function useEligibilityAccess(): EligibilityAccess {
  return { hasAccess: true, isLoading: false };
}
